<template>
  <v-list-item-content>
    <v-dialog v-model="show" ref="editDialog" max-width="500px" @keydown.esc="closeEditEditor" persistent>
      <v-card>
        <v-card-title>
            {{ $t('tasks.info.dialogTitleHouse') }}
          <v-btn icon absolute right>
            <v-icon class="clear" color="primary" :size="28" @click.native="closeEditEditor"/>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <PropertyObjects v-bind:form="select" :display-items="displayItems" :property-id="propertyId.toString()" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="closeEditEditor">{{ $t('common.buttons.cancel') }}</v-btn>
          <v-btn color="primary" @click.native="saveEditEditor">{{ $t('common.buttons.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      {{ $t('tasks.info.house') }}: {{ houseInfo }}
      <span v-if="!editDisabled">
        [<a @click.stop="openEditEditor">{{ $t('common.buttons.edit') }}</a>]
      </span>
    </div>
  </v-list-item-content>
</template>

<script>
import PropertyObjects from './PropertyObjects.vue'
import _cloneDeep from 'lodash.clonedeep'

export default {
  name: 'PropertyHouseEditor',
  components: {
    PropertyObjects
  },
  watch: {
    search (val) {
      val && this.querySelections(val)
    }
  },
  props: {
    propertyId: {
      type: String,
      default: () => ''
    },
    houseInfo: {
      type: String,
      default: ''
    },
    editDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      select: { value: null },
      show: false,
      form: {
        realEstateManager: null
      },
      displayItems: [],
      dataObjects: []
    }
  },
  created () {
    this.getPropertyHouses()
  },
  methods: {
    openEditEditor () {
      this.select = { value: null }
      this.show = true
    },
    closeEditEditor () {
      this.show = false
    },
    saveEditEditor () {
      if (this.select.value) {
        let selectedHouseId = this.select.value.houseId
        let house = _cloneDeep(this.dataObjects.find(x => x.houseId.toString() === selectedHouseId.toString()))
        this.$emit('houseChanged', house)
      }
      this.show = false
    },
    getPropertyHouses () {
      let that = this
      this.$abacusProperty.getPropertyById(that.propertyId).then(response => {
        that.dataObjects = response.data.objects
        if (that.dataObjects && that.dataObjects.length > 0) {
          that.dataObjects.forEach(object => {
            let text = '[' + object.houseId + ']' + ' ' + object.houseStreet
            let displayItem = {
              houseId: object.houseId,
              displayText: text
            }
            that.displayItems.push(displayItem)
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.v-list-item__content {
  float: left;
}
</style>
